module.exports = __webpack_public_path__ + "static/assets/181b5fac890880865e9131cde17e3d49.png";